import { Injectable } from '@angular/core';
import { HttpService } from '../../rest/http.service';
import { Observable } from 'rxjs';
import {Candidate, CandidateInfo} from '../../models/candidate'
import {StateList} from '../../models/statelist'
import {VirtueDropdown} from '../../models/dropdown'

const routes = {
    candidateMock: '/candidate.json',
    //statelist : '/statelist.json',
   // schoollist : '/schoollist.json',
    candidate: '/getBasicInfo',
    saveBasicInfo : '/saveBasicInfo',
    statelist : '/config/states?country=US',
    genders : '/config/getdropdownValue?dropdownName=config.gender',
    ethnicity : '/config/getdropdownValue?dropdownName=config.ethnicity',
    citizenship : '/config/getdropdownValue?dropdownName=citizenship.options',
    maritalstatus : '/config/getdropdownValue?dropdownName=marital.status',
    distroysession : '/killSession',
    validateToken:  '/validateSubscription?token='
};

@Injectable({
  providedIn: 'root',
})
export class CandidateService {
  public isProfileActive=true;
  public isAcadmicActive=true;
  public isInterestActive=true;
  public isOptionActive=true;
  constructor(private httpService : HttpService) { }

  get() : Observable<CandidateInfo> {
		return this.httpService.get(routes.candidate);
  }

  validateToken(token : string) : Observable<any> {
		return this.httpService.get(routes.validateToken + token);
  }

  getMock() : Observable<CandidateInfo> {
    return this.httpService.getMock(routes.candidateMock);
  }

  getStateList() : Observable<StateList> {
		return this.httpService.get(routes.statelist, 30);
  }

  getGenders() : Observable<VirtueDropdown> {
    return this.httpService.get(routes.genders, 30);
  }

  getEthnicity() : Observable<VirtueDropdown> {
    return this.httpService.get(routes.ethnicity, 30);
  }

  getCitizenShip() : Observable<VirtueDropdown> {
    return this.httpService.get(routes.citizenship, 30);
  }

  getMaritalStatus() : Observable<VirtueDropdown> {
    return this.httpService.get(routes.maritalstatus, 30);
  }

  post(candidate : Candidate) : Observable<any> {
    return this.httpService.post(routes.saveBasicInfo, candidate);
  }

  distroySession() : Observable<any> {
    return this.httpService.get(routes.distroysession);
  }
  isAcadmicActiveFrom(){
    return this.isAcadmicActive;
  }
  isInerestActiveFrom(){
    return this.isInterestActive;
  }
  isOptionFrom(){
    return this.isOptionActive;
  }
  setAcadmicActiveFrom(){
     this.isAcadmicActive =false;
  }
  setInerestActiveFrom(){
     this.isInterestActive=false;
  }
  serOptionFrom(){
     this.isOptionActive=false;
  }
}
